import { render, staticRenderFns } from "./PhysicalShopCollection.vue?vue&type=template&id=9bc5d892&"
import script from "./PhysicalShopCollection.vue?vue&type=script&lang=js&"
export * from "./PhysicalShopCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bc5d892')) {
      api.createRecord('9bc5d892', component.options)
    } else {
      api.reload('9bc5d892', component.options)
    }
    module.hot.accept("./PhysicalShopCollection.vue?vue&type=template&id=9bc5d892&", function () {
      api.rerender('9bc5d892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/PhysicalShopCollection.vue"
export default component.exports